import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQSection = ({ faqs }) => {
  return (
    <section 
      className="py-20 md:py-28"
      data-testid="faq-section"
    >
      <div className="max-w-3xl mx-auto px-4 md:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-nukleus-lilac mb-4 block">
            Got Questions?
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white tracking-tight">
            Frequently Asked Questions
          </h2>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={faq.id} 
              value={faq.id}
              className="bg-nukleus-card rounded-xl border border-white/5 px-6 overflow-hidden data-[state=open]:border-nukleus-violet/30 transition-colors"
              data-testid={`faq-${index}`}
            >
              <AccordionTrigger className="text-left text-white hover:no-underline py-5 [&>svg]:text-nukleus-violet">
                <span className="font-medium">{faq.question}</span>
              </AccordionTrigger>
              <AccordionContent className="text-white/60 pb-5 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
